import itemComponent from './item.component'
import ItemCreate from './create'
import ItemEdit from './edit'
import ItemAll from './all'
import printItemHistory from './print';

let itemModule = angular.module('items', [
    ItemCreate,
    ItemEdit,
    ItemAll,
    printItemHistory
  ])

  .component('items', itemComponent)

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $stateProvider
      
      .state('items.create', {
        url: '/create',
        component: 'itemcreate'
      })

      .state('items.edit', {
        url: '/edit/:id',
        component: 'itemedit'
      })

      .state('items.all', {
        url: '/all/:page',
        component: 'itemall'
      })
  })
  .name;

export default itemModule;


// WEBPACK FOOTER //
// ./client/app/components/item/index.js